import React from 'react'

import { logOutUser } from 'user/UserApi'
import { clearCachedLanguage } from 'i18n'

export const alertUser = (event: any) => {
  event.preventDefault()
  event.returnValue = 'Are you sure you want to close?'
}

export const removeBeforeunloadListener = () => {
  window.removeEventListener('beforeunload', alertUser)
}

export const addBeforeunloadListener = () => {
  window.addEventListener('beforeunload', alertUser)
}

export const beforeUnloadSetting = (): React.EffectCallback => {
  return () => {
    addBeforeunloadListener()
    return () => {
      removeBeforeunloadListener()
    }
  }
}

export const logoutUserAction = () => {
  logOutUser()
    .then(() => {
      window.sessionStorage.setItem('userSession', JSON.stringify({}))
      clearCachedLanguage()
      document.location.href = '/login'
    })
    .catch()
}
